export const URL_BASE_API = window.getEnv('REACT_APP_API_URL');
export const URL_IMG = 'assets/images/';
export const SENTRY_DNS_URL = window.getEnv('REACT_APP_SENTRY_URL');
export const SITE_URL = window.getEnv('REACT_APP_SITE_URL');
export const CHAT_BOT_URL = window.getEnv('CHAT_BOT_URL');
